import { render, staticRenderFns } from "./IncidentRecordsMenuItem.vue?vue&type=template&id=7551eca0"
import script from "./IncidentRecordsMenuItem.vue?vue&type=script&lang=js"
export * from "./IncidentRecordsMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports